window.globalHelpersModule.directive "autoFocus", ['$log', '$timeout', ($log, $timeout) ->
  restrict: 'AC'
  link: (scope, element) ->
    $timeout (->
      $(element[0]).focus()
      return
    ), 0
    return
]